import { createApp } from 'vue';
import { createPinia } from 'pinia';
import ElementPlus from 'element-plus';
import locale from 'element-plus/es/locale/lang/zh-cn';
import VueViewer, { directive as viewerDirective } from 'v-viewer';
import { useI18n } from '@/langs/i18n';
import App from './App.vue';
import router from './router';
import 'element-plus/theme-chalk/src/index.scss';
import '@/styles/index.scss';
import '@/assets/icon/iconfont.css';
import '@/assets/icon/iconfont.js';
import '@/utils/rem';
import 'viewerjs/dist/viewer.css';

const app = createApp(App);

app.use(createPinia());
app.use(router)
  .use(useI18n)
  .use(ElementPlus, { locale, size: 'default' });
app.use(VueViewer);
app.directive('viewer', viewerDirective({
  debug: true,
}));

app.mount('#app');
